import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientStoreService {

  private clientDetails = new BehaviorSubject<any>(null);

  client$ = this.clientDetails.asObservable();

  setClient(details: any) {
    this.clientDetails.next(details);
  }

  getClient() {
    return this.clientDetails.asObservable();
  }

  clearClient() {
    this.clientDetails.next(null);
  }
}
